module.exports = __webpack_public_path__ + "static/Astronaut-d824fe26f00ec455e6936c0100e4642f.svg";